import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/app-settings.tokens';
import { UsersResponse, UserSearchParams } from '../models/permissions.model';

@Injectable({
  providedIn: 'root'
})
export class UserSearchService {
  private apiUrl = `${inject(API_BASE_URL)}/api/v1/admin/users`;

  constructor(private http: HttpClient) {}

  /**
   * Search users with flexible filtering
   * @param params - Search parameters (name, userTypeId, pageNumber, pageSize, status, isActive)
   * @returns Observable<UsersResponse>
   */
  searchUsers(params: UserSearchParams): Observable<UsersResponse> {
    let httpParams = new HttpParams();

    // Set pagination
    httpParams = httpParams.set('pageNumber', params.pageNumber?.toString() || '1');
    httpParams = httpParams.set('pageSize', params.pageSize?.toString() || '10');

    // Set optional filters
    if (params.name) {
      httpParams = httpParams.set('name', params.name);
    }
    if (params.userTypeId) {
      httpParams = httpParams.set('userTypeId', params.userTypeId.toString());
    }
    if (params.status !== undefined) {
      httpParams = httpParams.set('status', params.status.toString());
    }
    if (params.isActive !== undefined) {
      httpParams = httpParams.set('isActive', params.isActive.toString());
    }

    return this.http.get<UsersResponse>(this.apiUrl, { params: httpParams });
  }

  /**
   * Search users by name
   * @param name - User name to search
   * @param pageNumber - Page number
   * @param pageSize - Items per page
   * @returns Observable<UsersResponse>
   */
  searchUsersByName(name: string, pageNumber: number = 1, pageSize: number = 10): Observable<UsersResponse> {
    return this.searchUsers({ name, pageNumber, pageSize });
  }

  /**
   * Get users by role/user type
   * @param userTypeId - User type ID
   * @param pageNumber - Page number
   * @param pageSize - Items per page
   * @returns Observable<UsersResponse>
   */
  getUsersByRole(userTypeId: number, pageNumber: number = 1, pageSize: number = 10): Observable<UsersResponse> {
    return this.searchUsers({ userTypeId, pageNumber, pageSize });
  }
}
